import(/* webpackMode: "eager" */ "/home/u267222869/domains/yellow-mole-845348.hostingersite.com/public_html/.builds/source/src/app/page.tsx");
